document.addEventListener('DOMContentLoaded', (event) => {
  var collapsibles = document.getElementsByClassName("collapsible");

  for (var panel of collapsibles) {
    var header = panel.querySelector('.collapsible--header');

    header.addEventListener("click", function() {
      var wrapper = this.parentElement.querySelector('.collapsible--content--wrapper');
      var content = this.parentElement.querySelector('.collapsible--content');

      this.parentElement.classList.toggle("collapsible--expanded");
      this.classList.toggle("collapsible--header-expanded");
      wrapper.classList.toggle("collapsible--content--wrapper-expanded")
      content.classList.toggle("collapsible--content-expanded");
    });
  }
});
